import _defineProperty from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useReducer, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
/**
 * Settings, is an object where we have all the extra data for our filters
 *
 * label, is just a nice name to show on the screen
 * type: string
 * defaul: ""
 *
 * order, indicates in which position the filters will be displayed on the screen
 * type: number,
 * default: 1
 *
 * fixed, indicates if this filter will be displayed inside de extra filters select or not
 * All filters with this property "ON" will be forcibly displayed
 * type: boolean,
 * default: false
 *
 * fixedUntil, indicates up to which screen size the filter should be displayed outside the extra filters select
 * type: number | null,
 * default: null
 *
 * disabled, if the filter can be used or not
 * type: boolean
 * default: true
 */

var settings = [{
  type: 'dias_fecha_publicacion',
  label: 'Fecha de publicación',
  order: 10,
  fixed: true,
  fixedUntil: null,
  disabled: false,
  icon: 'icon-light-calendar'
}, {
  type: 'area',
  label: 'Área',
  order: 20,
  fixed: true,
  fixedUntil: null,
  disabled: false,
  icon: 'icon-light-cube',
  options: {
    menuWidth: 'calc( 100% + 170px )'
  }
}, {
  type: 'subarea',
  label: 'Subárea',
  order: 30,
  fixed: true,
  fixedUntil: 1140,
  disabled: false,
  icon: 'icon-light-layers'
}, {
  type: 'provincia',
  label: 'Provincia',
  order: 40,
  fixed: true,
  fixedUntil: 1250,
  disabled: false,
  icon: 'icon-light-location-pin'
}, {
  type: 'localidad',
  label: 'Localidad',
  order: 50,
  fixed: true,
  fixedUntil: 3000,
  disabled: false,
  icon: 'icon-light-map'
}, {
  type: 'barrio',
  label: 'Barrio',
  order: 60,
  fixed: false,
  fixedUntil: null,
  disabled: true,
  icon: ''
}, {
  type: 'distancia',
  label: 'Distancia',
  order: 70,
  fixed: false,
  fixedUntil: null,
  disabled: true,
  icon: ''
}, {
  type: 'nivel_laboral',
  label: 'Nivel laboral',
  order: 80,
  fixed: false,
  fixedUntil: null,
  disabled: false,
  icon: 'icon-light-award'
}, {
  type: 'tipo_trabajo',
  label: 'Tipo de puesto',
  order: 90,
  fixed: false,
  fixedUntil: null,
  disabled: false,
  icon: 'icon-light-bookmark'
}, {
  type: 'modalidad_trabajo',
  label: 'Modalidad de trabajo',
  order: 100,
  fixed: false,
  fixedUntil: null,
  disabled: false,
  icon: 'icon-light-office'
}, {
  type: 'salario',
  label: 'Salario mensual',
  order: 110,
  fixed: false,
  fixedUntil: null,
  disabled: false,
  icon: 'icon-light-money',
  options: {
    prefix: 'portal.currency'
  }
}, {
  type: 'conocimiento',
  label: 'Conocimiento',
  order: 120,
  fixed: false,
  fixedUntil: null,
  disabled: true,
  icon: ''
}, {
  type: 'empleo_joven',
  label: 'Empleo joven',
  order: 130,
  fixed: false,
  fixedUntil: null,
  disabled: false,
  icon: 'icon-light-graduation-cap'
}, {
  type: 'apto_discapacitado',
  label: 'Postulantes con discapacidad',
  order: 140,
  fixed: false,
  fixedUntil: null,
  options: {
    withCheckbox: true
  },
  disabled: false,
  icon: 'icon-light-discapacity'
}];
/**
 * This function will merge each filter with its settings listed in controlObject{}
 */

var mergeFiltersSettings = function mergeFiltersSettings(filters, filtersApplied) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : settings;
  return settings.map(function (setting) {
    /**
     * =================================================================================================
     * CUANDO JUAMPI TERMINE CON LOS FILTROS DEBEMOS REEPLAZAR LA VALIDACION (e.type || e.id) POR e.type
     * TANTO EN FILTER COMO OPTIONSELECTED
     * =================================================================================================
     */
    var filter = filters ? filters.filter(function (e) {
      return (e.type || e.id) === setting.type;
    }) : [];
    var optionSelected = filtersApplied ? filtersApplied.filter(function (e) {
      return (e.type || e.id) === setting.type;
    }) : [];
    return Object.assign(Object.assign(Object.assign({}, setting), filter[0]), {
      optionSelected: optionSelected.length > 0 ? optionSelected : false,
      showFilter: filter.length > 0 || optionSelected.length > 0 || setting.fixed
    });
  }).filter(function (e) {
    return !e.disabled && e.showFilter;
  }).sort(function (a, b) {
    if (a.order > b.order) {
      return 1;
    }

    if (a.order < b.order) {
      return -1;
    }

    return 0;
  });
};

var initialFiltersState = {
  filters: [],
  filtersApplied: []
};

var FiltersReducer = function FiltersReducer(state, action) {
  switch (action.type) {
    case 'merge':
      return Object.assign(Object.assign({}, state), {
        filters: mergeFiltersSettings(action.filters, action.filtersApplied, settings)
      });

    case 'merge-applied':
      return Object.assign(Object.assign({}, state), {
        filtersApplied: action.filtersApplied
      });

    default:
      return state;
  }
}; // @todo: se podria mover a un lugar mas generico


var separateLocalidadFromProvincia = function separateLocalidadFromProvincia(provincia, localidad) {
  return localidad.replace(new RegExp("-".concat(provincia, "$")), '');
};

export var useFilters = function useFilters(_ref) {
  var allFilters = _ref.allFilters,
      allAppliedFilters = _ref.allAppliedFilters,
      urlService = _ref.urlService,
      routerMatch = _ref.routerMatch,
      filterSettings = _ref.filterSettings,
      defaultFilters = _ref.defaultFilters,
      _ref$searchAvisosV2En = _ref.searchAvisosV2Enabled,
      searchAvisosV2Enabled = _ref$searchAvisosV2En === void 0 ? false : _ref$searchAvisosV2En;

  var _useReducer = useReducer(FiltersReducer, initialFiltersState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  useEffect(function () {
    settings = filterSettings || settings;
  }, [filterSettings]);
  useEffect(function () {
    dispatch({
      type: 'merge',
      filters: allFilters,
      filtersApplied: allAppliedFilters
    });
    dispatch({
      type: 'merge-applied',
      filtersApplied: allAppliedFilters
    });
  }, [allFilters, allAppliedFilters]);
  var history = useHistory();

  var performFiltering = function performFiltering(name, option) {
    var filters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : state.filters;
    var filtros = urlService.parseURL(window.location.href, routerMatch);

    var changeFilter = function changeFilter() {
      if (name === 'localidad' && filtros.provincia) {
        filtros.localidad = searchAvisosV2Enabled ? option.value : separateLocalidadFromProvincia(filtros.provincia, option.value);
      } else {
        filtros[name] = option.value;
      }
    };

    var removeFilter = function removeFilter() {
      if (name === 'subarea') {
        var areaFilter = filters.filter(function (filter) {
          return filter.type === 'area';
        });
        var optionSelected = areaFilter[0].optionSelected;
        filtros[optionSelected[0].type] = optionSelected[0].idSemantico || optionSelected[0].id;
      }

      if (name === 'area') {
        delete filtros.subarea;
      }

      delete filtros[name];
    };

    var removeAllFilters = function removeAllFilters() {
      var _a;

      filtros = defaultFilters ? _defineProperty({}, defaultFilters.name, (_a = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.option) === null || _a === void 0 ? void 0 : _a.value) : [];
    };

    var removeAllFixedFilters = function removeAllFixedFilters() {
      var appliedFilters = Object.keys(filtros);
      var appliedFixedFilters = filters.filter(function (dynamicFilter) {
        return appliedFilters.includes(dynamicFilter.type) && !dynamicFilter.fixed;
      });
      filtros = appliedFixedFilters.reduce(function (acc, toBeDeleted) {
        delete acc[toBeDeleted.type];
        return acc;
      }, filtros);
    }; // eslint-disable-next-line no-unused-expressions


    option ? changeFilter() : removeFilter(); // eslint-disable-next-line no-unused-expressions

    name === 'all' && removeAllFilters(); // eslint-disable-next-line no-unused-expressions

    name === 'all-fixed' && removeAllFixedFilters();
    var fullURL = urlService.makeURL(filtros);
    history.push(fullURL);
  };

  return Object.assign(Object.assign({}, state), {
    performFiltering: performFiltering
  });
};